import DemoContext from "context/DemoContext";
import VideoContext from "context/VideoContext";
import React, { useContext, useEffect, useState } from "react";
import { Alert, Container, Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import {
  calculateDifferenceTodayPublic,
  convertUTCToLocal,
  convertUTCToLocalMeetingsFormat,
} from "utils/dateFormatter";
import "./publicprofile.css";
import { Rating } from "react-simple-star-rating";
import ApiContext from "context/ApiContext";
import { Field, Form, Formik } from "formik";
import { DEMO_STATUS_OPTIONS, GUEST_DEMO_CANCEL_RESCHEDULE_STATUS } from "utils/constants";
import { message } from "antd";
import { getPublicIP } from "utils/getPublicIP";
import axiosInstance from 'Services/axios';
import logger from "utils/logger";
import InfiniteScroll from "react-infinite-scroll-component";

const formatDate = (dateString) => {
  const date = new Date(dateString);
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const year = date.getFullYear();
  return `${month.toString().padStart(2, "0")}/${day
    .toString()
    .padStart(2, "0")}/${year}`;
};
const convertTime = (timeString) => {
  const [hours, minutes] = timeString.split(":");
  const suffix = hours >= 12 ? "PM" : "AM";
  let formattedHours = hours % 12 || 12;
  formattedHours = formattedHours < 10 ? `0${formattedHours}` : formattedHours;
  const formattedMinutes =
    minutes < 10 && minutes > 0 ? `${minutes}` : minutes;
  return `${formattedHours}:${formattedMinutes} ${suffix}`;
};

const MeetingStatusPublic = () => {
  const { publicDemoStatus, guestCancelAccepted } = useContext(DemoContext);
  const { setDemoId, setVideoCredentials } = useContext(VideoContext);
  const { hostGuestRating } = useContext(ApiContext);
  const [demoInfo, setDemoInfo] = useState(null);
  const [bestVideos, setBestVideos] = useState([]);
  const [nextBestVideos, setNextBestVideos] = useState(null);
  const [hasMore, setHasMore] = useState(true);
  const [loadingBestVideos, setLoadingBestVideos] = useState(false);
  const queryParams = new URLSearchParams(window.location.search);
  const userIdFromQuery = queryParams.get("uid");
  const currentDemoId = queryParams.get("demo");
  const details = (() => {
    try {
      // return JSON.parse(localStorage.getItem("DETAILS"));
      const data = JSON.parse(localStorage.getItem("DETAILS"));
      if (data?.sessionDetail?.id === currentDemoId) {
        return data;
      }
      return null;
    } catch {
      return null;
    }
  })();

  const resolvedUserId =
    details?.id ||
    queryParams.get("uid") ||
    null;

  const resolvedSource =
    details?.id
      ? "localstorage"
      : queryParams.get("uid")
      ? "uid"
      : "none";


  const [demoIdentifier, setDemoIdentifier] = useState(
    queryParams.get("demo") ? queryParams.get("demo") : ""
  );
  const [responseMessage, setResponseMessage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();
  
  const navigate = useNavigate();
  const checkReferencee = async (param) => {
    setLoading(true);
    try {
      let uid = null;
      let source = null;
      let ip = null;

      if (details?.id) {
        uid = details.id;
        source = "localstorage";
      } else if (queryParams.get("uid")) {
        uid = queryParams.get("uid");
        source = "uid";
      } else {
        ip = await getPublicIP();
        source = "ip";
      }

      const res = await publicDemoStatus(param, uid, source, ip);

      setDemoInfo(res.data.data);
    } catch (error) {
      logger.error("Public demo status fetch failed:", error);
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    if (queryParams.get("demo")) {
      checkReferencee(queryParams.get("demo"));
    }
  }, []);

  useEffect(() => {
    if (!demoInfo?.id) return;

    const fetchInitialVideos = async () => {
      try {
        setLoadingBestVideos(true);

        const res = await axiosInstance.get(
          `${process.env.REACT_APP_BASE_URL}/api/v1/best-of-meetings/?demo_id=${demoInfo.id}`
        );

        setBestVideos(res.data.data.results || []);
        setNextBestVideos(res.data.data.next);
        setHasMore(!!res.data.data.next);

      } catch (err) {
        logger.error("Best videos fetch error:", err);
        setBestVideos([]);
      } finally {
        setLoadingBestVideos(false);
      }
    };

    fetchInitialVideos();

  }, [demoInfo?.product?.tag]);

  const fetchMoreBestVideos = async () => {
    if (!nextBestVideos || loadingBestVideos) {
      setHasMore(false);
      return;
    }

    try {
      setLoadingBestVideos(true);

      const nextQuery = new URL(nextBestVideos).search;

      const res = await axiosInstance.get(
        `${process.env.REACT_APP_BASE_URL}/api/v1/best-of-meetings/${nextQuery}`
      );

      setBestVideos(prev => [
        ...prev,
        ...(res.data.data.results || [])
      ]);

      setNextBestVideos(res.data.data.next);
      setHasMore(!!res.data.data.next);

    } catch (err) {
      setHasMore(false);
    } finally {
      setLoadingBestVideos(false);
    }
  };

  const handleCancelDemo = async () => {
    setLoading(true);
      const response = guestCancelAccepted(demoIdentifier);
      response
        .then(function (response) {
          if (response.status === 200) {
            return checkReferencee(demoIdentifier); // Ensure the UI updates with the latest data
          }
        })
        .then(() => {
          messageApi.open({
            type: "success",
            content: GUEST_DEMO_CANCEL_RESCHEDULE_STATUS.CANCELLED,
            duration: 5,
          });
        })
          // setTimeout(() => {
          //   navigate("/");
          // }
          // , 2000);
          
        .catch(function (error) {
          console.log(error);
          messageApi.open({
            type: "error",
            content:GUEST_DEMO_CANCEL_RESCHEDULE_STATUS.CANCELLED_ERROR,
            duration: 5,
          })
        })
        .finally(() => {
          setLoading(false); // Stop the loader after everything is complete
        });
  }
  const handleRescheduleDemo = async () => {
    setLoading(true);
    
      const response = guestCancelAccepted(demoIdentifier);
      response
        .then(function (response) {
          if (response.status === 200) {
            return checkReferencee(demoIdentifier); // Ensure the UI updates with the latest data
          }
        })
        .then(() => {
          if (demoInfo?.store_reschedule_url) {
            messageApi.open({
              type: "success",
              content: GUEST_DEMO_CANCEL_RESCHEDULE_STATUS.REDIRECTING,
              duration: 5,
            });
            window.location = demoInfo.store_reschedule_url; // Redirect to the reschedule URL
          }else{
            messageApi.open({
              type: "success",
              content: GUEST_DEMO_CANCEL_RESCHEDULE_STATUS.REDIRECTING_ERROR,
              duration: 5,
            });
          }
        })
        .catch(function (error) {
          console.log(error);
          messageApi.open({
            type: "error",
            content:GUEST_DEMO_CANCEL_RESCHEDULE_STATUS.RESCHEDULED_ERROR,
            duration: 5,
          })
        })
        .finally(() => {
          setLoading(false); // Stop the loader after everything is complete
        });
   
  }
  

  return (
    <Container className="mt-4">
      {contextHolder}
      <div className="row">
        <div className="schedule-image-wrapper d-flex justify-content-center col-12 col-sm-12 col-md-3 col-lg-3">
          <img
            src="https://cdn.shopify.com/extensions/90266465-eaf3-4ba9-945b-37b7bb21320c/11.27.0/assets/murphy-img.png"
            alt=""
          />
        </div>
        <div className="schedule-text-content col-12 col-sm-12 col-md-4 col-lg-4">
          <div className="heading-wrapper">Product Video meeting</div>
          <div className="detail-wrapper">
            <p>
              Connect with previous customers to get honest feedback about our
              products and services and get discounts on your purchase!
            </p>
            <br />
            <p>Hosted by</p>
          </div>
          <div className="logo-wrapper">
            <img
              src="https://cdn.shopify.com/extensions/90266465-eaf3-4ba9-945b-37b7bb21320c/11.27.0/assets/purebrand-guest-logo.png"
              alt="purebrand"
              onClick={() => navigate("/")}
            />
          </div>
        </div>
        <div className="demo-button-wrapper col-12 col-sm-12 col-md-5 col-lg-5">
          <div className="enabled-video-wrapper">
            {/* <div className="status-check-title"> 
              
            </div> */}
            <label htmlFor="demo-reference-id">
              Enter the reference id to check video meeting status.
            </label>
            <div className="reference-wrapper mt-3">
              <div className="form-group">
                <input
                  type="text"
                  id="demo-reference-id"
                  name="demo-reference-id"
                  placeholder="Reference ID"
                  className="form-control"
                  value={demoIdentifier}
                  onChange={(e) => setDemoIdentifier(e.target.value)}
                />
              </div>

              <div className="d-flex flex-column flex-wrap gap-3 mb-4">
                <div className="d-flex flex-row align-items-center flex-wrap gap-3">
                  <button
                    id="check-demo-status"
                    className="btn btn-primary px-4 py-2"
                    onClick={() => checkReferencee(demoIdentifier)}
                  >
                    Check Status
                  </button>
                  {demoInfo && (
                    <div className="align-self-center">
                      {demoInfo?.moderation?.demo_terminated ||
                      demoInfo?.moderation?.guest_removed ? (
                        <Alert variant="danger" className="mb-0">
                          <strong>
                            {demoInfo.moderation.demo_terminated
                              ? "Obscene content"
                              : "Removed from meeting"}
                          </strong>
                          <p className="mb-0 mt-2">
                            {demoInfo.moderation.message ||
                              "You cannot rejoin this meeting."}
                          </p>
                        </Alert>
                      ) : demoInfo?.status === "ENDED" && demoInfo?.resolved_guest ? (
                        <p className="mb-0">Meeting Concluded. Take a moment to rate the host.</p>
                      ) : demoInfo?.status === 'CANCELED' ?         
                        <p className="mb-0">
                          This video meeting was canceled.
                        </p>
                        :
                        calculateDifferenceTodayPublic(
                          demoInfo?.schedule.scheduled_date + "T" + demoInfo?.schedule.scheduled_time,
                          "minutes"
                        ) >= 5 &&
                        (Object.keys(demoInfo?.meeting_details).length === 0 ||
                          demoInfo?.status === DEMO_STATUS_OPTIONS.ACCEPTED) ? (
                        <p className="mb-0">
                          The meeting is scheduled to start at{" "}
                          {convertTime(
                            convertUTCToLocal(
                              demoInfo.schedule.scheduled_date +
                                "T" +
                                demoInfo.schedule.scheduled_time
                            )[1]
                          )}
                          ,{" "}
                          {
                            convertUTCToLocalMeetingsFormat(
                              demoInfo.schedule.scheduled_date +
                                'T' +
                                demoInfo.schedule.scheduled_time
                            )[0]
                          }
                        </p>
                      ) : calculateDifferenceTodayPublic(
                        demoInfo?.schedule.scheduled_date +
                          "T" +
                          demoInfo?.schedule.scheduled_time,
                          "minutes"
                        ) <= 5 &&
                        calculateDifferenceTodayPublic(
                        demoInfo?.schedule.scheduled_date +
                          "T" +
                          demoInfo?.schedule.scheduled_time,
                          "minutes"
                        ) >= -30 &&
                        (Object.keys(demoInfo?.meeting_details).length === 0 ||
                          demoInfo?.status === DEMO_STATUS_OPTIONS.ACCEPTED) ? (
                        <p className="mb-0">
                          The Real Customer must start the meeting before you can join.
                          <br /> Please try again in a moment.
                        </p>
                      ) : calculateDifferenceTodayPublic(
                        demoInfo?.schedule.scheduled_date +
                          "T" +
                          demoInfo?.schedule.scheduled_time,
                          "minutes"
                        ) <= 5 &&
                      Object.keys(demoInfo?.meeting_details).length !== 0 && demoInfo?.status !== DEMO_STATUS_OPTIONS.ACCEPTED ? (
                        <button
                          className="btn btn-primary px-4 py-2"
                          onClick={async () => {
                            setDemoId(demoInfo?.id);
                            const data = {
                              apikey: process.env.REACT_APP_VONAGE_API_KEY,
                              sessionId: demoInfo?.meeting_details?.session_id,
                              token: demoInfo?.meeting_details?.guest_token,
                            };
                          localStorage.setItem(
                            "videoToken",
                            JSON.stringify(data)
                          );
                            setVideoCredentials(data);
                            navigate(`/demo/waiting-room/${demoInfo?.id}`, {
                            state: {
                              eventDetail: demoInfo,
                              direct: "yes",
                            },
                            });
                          }}
                        >
                          Join Video meeting
                        </button>
                      ) : ( calculateDifferenceTodayPublic(
                          demoInfo?.schedule.scheduled_date + "T" + demoInfo?.schedule.scheduled_time,
                          "minutes"
                        ) < -30) ? (
                        <p className="mb-0">
                          We're sorry! It looks like your Real Customer was not able to make it.
                          <br />
                          <a href="https://murphydoor.com/pages/showrooms">Please try scheduling again.</a>
                        </p>
                      ) : null}
                      {/* {Object.keys(demoInfo?.meeting_details).length === 0 ||
                    demoInfo?.status === "ENDED" ? (
                      <>Meeting Concluded</>
                    ) : (
                      <button
                        className="btn btn-primary mt-3 join-demo-button"
                        onClick={() => {
                          setDemoId(demoInfo?.id);

                          const data = {
                            apikey: process.env.REACT_APP_VONAGE_API_KEY,
                            sessionId: demoInfo?.meeting_details?.session_id,
                            token: demoInfo?.meeting_details?.guest_token,
                          };
                          localStorage.setItem(
                            "videoToken",
                            JSON.stringify(data)
                          );
                          setVideoCredentials(data);
                          navigate("/demo/waiting-room", {
                            state: {
                              eventDetail: demoInfo,
                              direct: "yes",
                            },
                          });
                        }}
                      >
                        Join Video Meeting
                      </button>
                    )} */}
                    </div>
                  )}
                </div>

                {['ACCEPTED', 'UNDECIDED'].includes(demoInfo?.status) && !demoInfo?.is_live_meeting && <div className="d-flex flex-wrap gap-3">
                  <button className="btn btn-primary px-4 py-2" onClick={handleCancelDemo}>
                    Cancel
                  </button>
                  {
                  demoInfo?.store_reschedule_url ? <button className="btn btn-primary px-4 py-2" onClick={handleRescheduleDemo}>
                    Reschedule Video meeting
                  </button>
                  : null
                  }
                </div>}
              </div>

              {demoInfo?.status === "ENDED" && demoInfo?.resolved_guest ? (
                <div className="rating_wrapper">
                  <Formik
                    initialValues={{
                      rating: "",
                      guest_review_note: "",
                    }}
                    onSubmit={async (e) => {
                    try {
                      const ratingValue = parseInt((parseFloat(e.rating) / 5) * 100);

                      await axiosInstance.put(
                            `${process.env.REACT_APP_BASE_URL}/api/v1/demo-rating/${demoInfo.id}/`,
                            {
                              user_id: demoInfo.resolved_guest.id,
                              rating: ratingValue,
                              guest_review_note: e.guest_review_note,
                            }
                          );

                          setResponseMessage("Rating submitted successfully");
                        } catch (error) {
                          logger.error("Rating submission failed:", error);
                          messageApi.error("Failed to submit rating");
                        }
                      }}
                  >
                    {({ setFieldValue }) => (
                      <Form>
                        <div className="rating_elements">
                          <Rating
                            transition
                            allowFraction
                            initialValue={0}
                            className="mt-3"
                            onClick={(e) => setFieldValue("rating", e)}
                          />
                          <Field
                            as="textarea"
                            name="guest_review_note"
                            rows={3}
                            placeholder="Add a comment"
                            className="form-control mt-3"
                          />
                          <button
                            className="btn btn-outline-primary btn-sm mt-3"
                            type="submit"
                          >
                            Rate
                          </button>
                          {responseMessage ? (
                            <Alert className="mt-3" variant="success">
                              {responseMessage}
                            </Alert>
                          ) : null}
                        </div>
                      </Form>
                    )}
                  </Formik>
                </div>
              ) : null}
            </div>
          </div>
          {loading === true ? (
            <div className="d-flex justify-content-center">
              <Spinner animation="grow" color="#57b0de" />
              <Spinner animation="grow" color="#57b0de" />
              <Spinner animation="grow" color="#57b0de" />
            </div>
          ) : (
            <div className="meeting-status-wrapper hide mt-3">
              {demoInfo ? (
                <div>
                  {" "}
                  <div className="meeting-status">
                    <strong>Store:</strong> {demoInfo?.store.name}
                    <br />
                    <strong>Meeting Status:</strong> {demoInfo?.status}
                    <br />
                    {demoInfo?.members ? (
                      <>
                        {demoInfo?.resolved_guest && (
                          <>
                          <strong>Guest:</strong> {demoInfo.resolved_guest.full_name}
                          <br />
                          </>
                        )}
                        {demoInfo?.members.host_detail ? (
                          <>
                            <strong>Real Customer: </strong>{" "}
                            {demoInfo?.members.host_detail.first_name}{" "}
                            {(demoInfo?.members.host_detail.last_name).charAt(
                              0
                            )}
                            .
                            <br />
                          </>
                        ) : null}
                      </>
                    ) : null}
                    {demoInfo?.schedule?.scheduled_date !== null ? (
                      <>
                        <strong>Date: </strong>
                        {
                          convertUTCToLocalMeetingsFormat(
                            demoInfo.schedule.scheduled_date +
                              'T' +
                              demoInfo.schedule.scheduled_time
                          )[0]
                        }
                      </>
                    ) : (
                      ""
                    )}
                    <br />
                    {demoInfo?.schedule?.scheduled_date !== null ? (
                      <>
                        <strong>Time: </strong>
                        {convertTime(
                          convertUTCToLocal(
                            demoInfo.schedule.scheduled_date +
                              "T" +
                              demoInfo.schedule.scheduled_time
                          )[1]
                        )}
                      </>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="meeting-error-response"></div>
                </div>
              ) : null}
            </div>
          )}
        </div>
      </div>
      {bestVideos.length > 0 && demoInfo?.status !== "ENDED" &&(
        <div
          className="mt-5"
          style={{
            textAlign: bestVideos.length === 1 ? "center" : "left",
          }}
        >
          <h4>
            While you wait, watch these past video{bestVideos.length !== 1 ? "s" : ""}
          </h4>

          <div
            id="videoScrollContainer"
            style={{
              maxHeight: "250px",
              overflow: "auto",
            }}
          >
            <InfiniteScroll
              dataLength={bestVideos.length}
              next={fetchMoreBestVideos}
              hasMore={hasMore}
              loader={
                <div className="d-flex justify-content-center mt-3">
                  <Spinner animation="grow" />
                </div>
              }
              scrollableTarget="videoScrollContainer"
            >
            <div className="video-grid"
              style={
                bestVideos.length === 1
                  ? {
                      display: "flex",
                      justifyContent: "center",
                    }
                  : {}
              }>
              {bestVideos.map((video) => (
                <div key={video.id} className="video-card"
                style={
                  bestVideos.length === 1
                    ? { maxWidth: "320px", width: "100%" }
                    : {}
                }>
                  <video controls preload="metadata" poster={video.thumbnail}>
                    <source src={video.video} type="video/mp4" />
                  </video>
                </div>
              ))}
            </div>
          </InfiniteScroll>
        </div>
        </div>
      )}
    </Container>
    
  );
};

export default MeetingStatusPublic;